import mContentCard300 from "../Card/ContentCard300";
import mContentCard1 from "../Card/ContentCard1";
import mContentCard515 from "../Card/ContentCard515";
import mContentCard901 from "../Card/ContentCard901";
import mContentCard905 from "../Card/ContentCard905";
import mContentCard907 from "../Card/ContentCard907";
import mContentCard908 from "../Card/ContentCard908";
import mContentCard910 from "../Card/ContentCard910";
import mContentCard801 from "../Card/ContentCard801";
import mContentCard913 from "../Card/ContentCard913.vue";
import mContentCardCounter1 from "../Card/ContentCardCounter1";
import mContentCard2 from "../Card/ContentCard2";
import mContentCard911 from "../Card/ContentCard911";
import mContentCard912 from "../Card/ContentCard912";
import mContentCard914 from "../Card/ContentCard914";
import mContentCard915 from "../Card/ContentCard915";
import mContentCard916 from "../Card/ContentCard916";
import mContentCard919 from "../Card/ContentCard919";
import mContentCard920 from "../Card/ContentCard920";
import mContentCard921 from "../Card/ContentCard921";
import mContentCard923 from "../Card/ContentCard923";
import mContentCard917 from "../Card/ContentCard917";
import mContentCard908s from "../Card/ContentCard908s.vue";
import mContentCard310 from "../Card/ContentCard310";
import mContentCard204 from "../Card/ContentCard204.vue";
import mContentCard205 from "../Card/ContentCard205.vue";
import mContentCard206 from "../Card/ContentCard206.vue";
import mContentCard316 from "../Card/ContentCard316.vue";
import mContentCard500 from "../Card/ContentCard500.vue";
import mContentCard501 from "../Card/ContentCard501.vue";
import mContentCard502 from "../Card/ContentCard502.vue";
import mContentCard503 from "../Card/ContentCard503.vue";
import mContentCardUnKnow300 from "../Card/ContentCardUnKnow300.vue";


export const Cards = {
    mContentCard300,
    mContentCard1,
    mContentCard515,
    mContentCard901,
    mContentCard905,
    mContentCard907,
    mContentCard908,
    mContentCard908s,
    mContentCard910,
    mContentCard801,
    mContentCardCounter1,
    mContentCard913,
    mContentCard2,
    mContentCard911,
    mContentCard912,
    mContentCard914,
    mContentCard915,
    mContentCard916,
    mContentCard919,
    mContentCard920,
    mContentCard921,
    mContentCard923,
    mContentCard917,
    mContentCard310,
    mContentCard204,
    mContentCard205,
    mContentCard206,
    mContentCard316,
    mContentCard500,
    mContentCard501,
    mContentCard502,
    mContentCard503,
    mContentCardUnKnow300,
}